export type MembersLivingFilter = 'all' | 'living' | 'deceased';

export type MembersSortBy = 'last-first' | 'first' | 'birth' | 'recent';

export type MembersSortDirection = 'asc' | 'desc';

export function defaultSortDirection(sortBy: MembersSortBy): MembersSortDirection {
  return sortBy === 'recent' ? 'desc' : 'asc';
}

export interface MembersPeopleFilters {
  living: MembersLivingFilter;
  hasPhoto: boolean;
  hasNoRelationships: boolean;
}

export const DEFAULT_MEMBERS_PEOPLE_FILTERS: MembersPeopleFilters = {
  living: 'all',
  hasPhoto: false,
  hasNoRelationships: false
};
